import { render, staticRenderFns } from "./addCIn.vue?vue&type=template&id=1b057fbe&scoped=true&"
import script from "./addCIn.vue?vue&type=script&lang=js&"
export * from "./addCIn.vue?vue&type=script&lang=js&"
import style0 from "./addCIn.vue?vue&type=style&index=0&id=1b057fbe&prod&scoped=true&lang=css&"
import style1 from "./addCIn.vue?vue&type=style&index=1&id=1b057fbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b057fbe",
  null
  
)

export default component.exports